"use client";

import clsx from "clsx";
import React from "react";
import AgentHeader from "./AgentHeader";
import FileBubbleActions from "./FileBubbleActions";

/**
 * Shared wrapper around a file/artifact card. Handles the agent header,
 * alignment, spacing, and trailing actions row — callers supply only the card
 * body. Kept deliberately presentational (no context reads, no effects) so
 * both AskFileBubble and AskGeneratedFileBubble can reuse it without coupling
 * to the artifact-panel context.
 */
const FileBubbleFrame: React.FC<{
   isUser?: boolean;
   agentName?: string;
   brandOverride?: string;
   className?: string;
   isLastInGroup?: boolean;
   hideAgentHeader?: boolean;
   feedbackSlot?: React.ReactNode;
   copyText?: string;
   children: React.ReactNode;
}> = ({
   isUser,
   agentName,
   brandOverride,
   className,
   isLastInGroup = true,
   hideAgentHeader = false,
   feedbackSlot,
   copyText,
   children,
}) => {
   const showHeader = !isUser && !hideAgentHeader;

   return (
      <div
         className={clsx(
            "text-sm monument-font",
            {
               "mb-4": !isUser || isLastInGroup,
               "mb-0": isUser && !isLastInGroup,
               "mt-1": hideAgentHeader && !isUser,
            },
            className,
            {"ml-auto": isUser}
         )}
      >
         {showHeader && <AgentHeader brandOverride={brandOverride} agentName={agentName} />}
         {children}
         {!isUser && (copyText || feedbackSlot) && (
            <FileBubbleActions copyText={copyText} feedbackSlot={feedbackSlot} />
         )}
      </div>
   );
};

export default FileBubbleFrame;
